import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/company-profile.css';

const TABS = [
  { key: 'overview', label: 'Overview', suffix: '' },
  { key: 'about', label: 'About', suffix: '/about' },
  { key: 'services', label: 'Services', suffix: '/services' },
  { key: 'contact', label: 'Contact', suffix: '/contact' }
];

export default function CompanySubNav({ companyId, active }) {
  const navigate = useNavigate();

  return (
    <div className="company-subnav-bar">
      <nav className="company-nav">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`company-nav-link ${active === tab.key ? 'active' : ''}`}
            onClick={() => navigate(`/company/${companyId}${tab.suffix}`)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
